<div class="flex flex-col gap-2 p-5 w-full">
    <!-- File Upload -->
    <app-admin-file-management-upload [acceptType]="AdminFileType.ACCISE_GAS" (finished)="loadAcciseGas()"
        [toast]="toast"></app-admin-file-management-upload>

    <!-- Table -->
    <p class=" texl-lg font-semibold mt-2">{{ 'admin.history' | transloco}}</p>
    <div class="w-full flex flex-col gap-2">
        <div
            class="overflow-x-auto max-w-ultrawide justify-center mb-4 mobile:max-w-screen block min-h-[300px] h-full overflow-y-auto rounded-[16px]">
            <table class="table w-full">
                <thead class="bg-primary-100 text-neutral-700 uppercase">
                    <tr class="max-h-[50px]">
                        <th class="border-b border-border px-4 py-4 font-normal">{{
                            'archive.overview.file_name' | transloco }}
                        </th>
                        <th class="border-b border-border px-4 py-4 font-normal">{{
                            'admin.upload_date' | transloco }}
                        </th>
                        <th class="border-b border-border px-4 py-4 font-normal text-end">{{
                            'settings.table.actions' |
                            transloco }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of acciseGasFiles; let i = index">
                        <tr class="max-h-[50px] bg-white text-black">
                            <td class="border-b border-border px-4 py-4">{{ item.filename }}</td>
                            <td class="border-b border-border px-4 py-4">{{ item.uploaded_at | isoDate}}
                            </td>
                            <td class="border-b border-border px-4 py-4">
                                <div class="flex gap-2 items-center justify-end">
                                    <button (click)="downloadFile(item.id)">
                                        <p class="text-primary hover:text-primary-1500">
                                            {{ 'shared.download' | transloco }}</p>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>